var React = require('react');

function InPersonFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.1483 6.24586L12.5983 1.00586C11.3183 -0.0141418 9.31832 -0.0241418 8.04832 0.995858L1.49832 6.24586C0.558322 6.99586 -0.0116777 8.49586 0.188322 9.67586L1.44832 17.2159C1.73832 18.9059 3.30832 20.2359 5.01832 20.2359H15.6183C17.3083 20.2359 18.9083 18.8759 19.1983 17.2059L20.4583 9.66586C20.6383 8.49586 20.0683 6.99586 19.1483 6.24586ZM11.0683 16.2359C11.0683 16.6459 10.7283 16.9859 10.3183 16.9859C9.90832 16.9859 9.56832 16.6459 9.56832 16.2359V13.2359C9.56832 12.8259 9.90832 12.4859 10.3183 12.4859C10.7283 12.4859 11.0683 12.8259 11.0683 13.2359V16.2359Z","fill":"#292D32"}));
}

InPersonFilled.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = InPersonFilled;

InPersonFilled.default = InPersonFilled;
